import React from 'react';
import TextField from '@material-ui/core/TextField';

const TextFieldMUI = React.forwardRef(function TextFieldMUI(props, ref) {
  return <TextField {...props} ref={ref} InputLabelProps={{ shrink: true }} />;
});

export default TextFieldMUI;
